export const LOAD_VISUALS = "LOAD_VISUALS";
export const LOAD_VISUALS_SUCCESS = "LOAD_VISUALS_SUCCESS";
export const LOAD_VISUALS_ERROR = "LOAD_VISUALS_ERROR";
